import {writable} from 'svelte/store';

let categoriesObject = {
    tree: [],

    selected_id: 0,
    edit_id: null,
    search_term: '',
};

const {get, set, update, subscribe} = writable(categoriesObject)

const categories = {
    subscribe,
    update,
    set: o => {
        set(categoriesObject);
    },
}

export default categories;